// Base configuration for all environments
const config = {
  development: {
    API_BASE_URL: 'http://localhost:3222'
  },
  production: {
    API_BASE_URL: 'https://cockpit.globe-groupe.com' // Empty string for relative paths in production
  },
  test: {
    API_BASE_URL: 'http://localhost:3222'
  }
};

// Get current environment, fallback to 'development' if not set
const env = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment.
// `??` et pas `||` : en Docker on passe REACT_APP_API_BASE_URL="" pour taper le
// même origin que le front (tout passe par nginx), et "" est falsy.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? config[env].API_BASE_URL;

// Bascule vers l'auth Connect (OIDC/BFF). Doit refléter CONNECT_ENABLED côté backend.
export const CONNECT_ENABLED = process.env.REACT_APP_CONNECT_ENABLED === 'true';

// Connect's public URL. The frontend only uses it for the SSO session
// keep-alive (GET /oauth/ping) — authentication itself goes through the BFF.
export const CONNECT_UI_URL = process.env.REACT_APP_CONNECT_UI_URL || 'https://connect.globe-groupe.com';

// The app's own identity, not configuration: the same client_id in every
// environment, preview deployments included. A second copy in the env only
// created a way for it to drift from the backend's CONNECT_CLIENT_ID.
export const CONNECT_CLIENT_ID = 'cockpit';

// Base URLs of the apps embedded in cockpit tabs, overridable per environment
// (hardcoded prod hosts would frame the prod app and its separate session).
export const GALLERY_APP_URL = process.env.REACT_APP_GALLERY_APP_URL || 'https://gallery.globe-groupe.com';
export const BI_APP_URL = process.env.REACT_APP_BI_APP_URL || 'https://bi.globe-groupe.com';
export const WEEKLY_APP_URL = process.env.REACT_APP_WEEKLY_APP_URL || 'https://weekly.globe-groupe.com';

// Attributs du cookie legacy `authToken` — ne servent plus qu'à sa PURGE
// (utils/cookies.js) : la suppression doit viser le même domaine que la pose.
export const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN || '.globe-groupe.com';
export const COOKIE_SECURE = process.env.NODE_ENV === 'production'; // true en production, false en développement

// You can add more configuration exports here if needed
export default {
  API_BASE_URL
};
